// --- smooth scroll --------------

// lenis smooth scroll
const lenis = new Lenis({
  smoothWheel: true, // Smooth wheel behavior
  smoothTouch: false, // Disable smooth touch scrolling (if needed)
  normalizeWheel: true, // Normalize wheel events
  // Ignore elements with the class 'scroll-section' (or any other class you use)
  ignore: (el) => el.classList.contains("scroll-section"),
});

lenis.on("scroll", ScrollTrigger.update);
gsap.ticker.add((time) => {
  lenis.raf(time * 700);
});

gsap.ticker.lagSmoothing(0);

// --- smooth scroll --------------

// --------- header clock -------------

function updateIndianTime() {
  const options = {
    timeZone: "Asia/Kolkata",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };

  const indianTime = new Date().toLocaleTimeString("en-IN", options);
  const timeElements = document.getElementsByClassName("ind-time");

  Array.from(timeElements).forEach((element) => {
    element.innerHTML = `INDIA &nbsp;&nbsp;&nbsp; ${indianTime}`;
  });
}
updateIndianTime();
setInterval(updateIndianTime, 1000);
// --------- header clock -------------

//---------------- Header cart total update--------------------------
// Select the element that displays the cart total
function formatINR(amount) {
  return new Intl.NumberFormat("en-IN", {
    currency: "INR",
    minimumFractionDigits: 2,
  }).format(amount / 100);
}
let lastCartTotal = null;
document.addEventListener("DOMContentLoaded", () => {
  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    if (
      args[0].includes("/add") ||
      args[0].includes("/change") ||
      args[0].includes("/update")
    ) {
      fetch("/cart.js")
        .then((res) => res.json())
        .then((cart) => {
          if (cart.total_price !== lastCartTotal) {
            lastCartTotal = cart.total_price;
            document.querySelector(
              ".header-cart-total"
            ).innerText = `RS. ${formatINR(lastCartTotal)}`;
          }
        });
    }

    return response;
  };
});
//---------------- Header cart total update END--------------------------

// ================= Menu Drawer ===================

const menuBtn = document.querySelector(".top-right-four .m-menu");
const menuCont = document.querySelector(".menu-cont");

menuBtn.addEventListener("click", () => {
  menuCont.classList.toggle("active");
});

function closeMenu() {
  menuCont.classList.remove("active");
}

// ================= Menu Drawer ===================

// --------------------Draggable Scroll --------------------------------

function initDragToScroll(container) {
  if (!container) return;
  let isDragging = false;
  let startX = 0;
  let scrollLeft = 0;
  let currentX = 0;
  let rafId = null;
  let hasDragged = false;
  const dragThreshold = 5;

  // Prevent images from being dragged
  container.querySelectorAll("img").forEach((img) => {
    img.setAttribute("draggable", "false");
  });

  // Disable or enable anchor interactions and text selection
  const toggleAnchors = (disable) => {
    container.querySelectorAll("a").forEach((anchor) => {
      anchor.style.pointerEvents = disable ? "none" : "";
      anchor.style.userSelect = disable ? "none" : "";
    });
  };

  // Toggle text selection on the container itself
  const toggleContainerSelection = (disable) => {
    container.style.userSelect = disable ? "none" : "";
  };

  // Smoothly update scroll position while dragging
  const smoothScroll = () => {
    if (!isDragging) return;

    const distance = currentX - startX;

    if (Math.abs(distance) > dragThreshold && !hasDragged) {
      hasDragged = true;
      toggleAnchors(true);
      toggleContainerSelection(true);
    }

    container.scrollLeft = scrollLeft - distance;
    rafId = requestAnimationFrame(smoothScroll);
  };

  const startDragging = (e) => {
        const target = e.target;
        if (target.closest("input, textarea, select, button ,.confirm-btn,p,h1,h2,span")) return; // Skip form elements
    isDragging = true;
    hasDragged = false;
    startX = e.pageX;
    currentX = startX;
    scrollLeft = container.scrollLeft;

    e.preventDefault(); // Prevent text selection
    container.classList.add("dragging");

    cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(smoothScroll);
  };

  const stopDragging = () => {
    isDragging = false;
    container.classList.remove("dragging");
    cancelAnimationFrame(rafId);

    // Re-enable interactions after drag ends
    setTimeout(() => {
      toggleAnchors(false);
      toggleContainerSelection(false);
      hasDragged = false;
    }, 0);
  };

  // Event listeners
  container.addEventListener("mousedown", startDragging);
  container.addEventListener("mousemove", (e) => {
    if (isDragging) {
      currentX = e.pageX;
    }
  });
  container.addEventListener("mouseup", stopDragging);
  container.addEventListener("mouseleave", stopDragging);

  // Prevent link clicks if dragged
  container.addEventListener("click", (e) => {
    if (hasDragged) {
      e.preventDefault();
      e.stopPropagation();
    }
  });
}

// Initialize drag-to-scroll on all sliders
document.addEventListener("DOMContentLoaded", () => {
  // Custome Scroll
  // initDragToScroll(document.querySelector('.sect6-flex-container'));
  // initDragToScroll(document.querySelector('product__media-list'));

  // Shopify Product Scroll Use This
  const sliders = document.querySelectorAll(".grid");
  sliders.forEach((slider) => initDragToScroll(slider));
});

// --------------------Draggable Scroll --------------------------------

// --------------------Footer Accordian --------------------------------

// // // // // // Edited BY Nikita // // // // // // 
(function() {
  const initializeAccordion = () => {
    const accordionHeaders = document.querySelectorAll('.f-navlist p');

    // Restore open submenu index from sessionStorage
    const openIndex = sessionStorage.getItem('openFooterSubmenu');
    if (openIndex !== null && accordionHeaders[openIndex]) {
      accordionHeaders[openIndex].classList.add('active');
      const content = accordionHeaders[openIndex].nextElementSibling;
      if (content) {
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    }

    accordionHeaders.forEach((header, index) => {
      header.removeEventListener('click', toggleAccordion);
      header.addEventListener('click', () => toggleAccordion(event, index));
    });
  };

  const toggleAccordion = (event, index) => {
    const clickedHeader = event.currentTarget;
    const accordionHeaders = document.querySelectorAll('.f-navlist p');
    const activeHeader = document.querySelector('.f-navlist p.active');

    // Close previously active, if it's not the clicked one
    if (activeHeader && activeHeader !== clickedHeader) {
      activeHeader.classList.remove('active');
      if (activeHeader.nextElementSibling) {
        activeHeader.nextElementSibling.style.maxHeight = 0;
      }
    }

    // Toggle clicked header
    clickedHeader.classList.toggle('active');
    const content = clickedHeader.nextElementSibling;

    if (content) {
      if (clickedHeader.classList.contains('active')) {
        content.style.maxHeight = content.scrollHeight + 'px';
        // Save index in sessionStorage
        sessionStorage.setItem('openFooterSubmenu', index);
      } else {
        content.style.maxHeight = 0;
        // Remove from sessionStorage if closing
        sessionStorage.removeItem('openFooterSubmenu');
      }
    }
  };

  initializeAccordion();
})();

////Home Hero Section Javascript/////
  window.addEventListener('load', function () {
    const leftContent = document.querySelector('.left-content');
    const imageContent = document.querySelector('.image-content');
    const rightContent = document.querySelector('.right-content');
    const mobileImage = document.querySelector('.mobile-img');

    if (!leftContent || !imageContent || !rightContent || !mobileImage) return;

    function applyParallax() {
      const y = window.scrollY;
      leftContent.style.transform = `translateY(${y * -0.3}px)`;
      imageContent.style.transform = `translateY(${y * -0.3}px)`;
      rightContent.style.transform = `translateY(${y * -0.3}px)`;
      mobileImage.style.transform = `translateY(${y * -0.3}px)`;
    }

    window.addEventListener('scroll', applyParallax);
  });
////Home Hero Section Javascript/////


////Vertical Carousel//////
  const sections = Array.from(document.querySelectorAll('.ron-stack'));
  const texts    = Array.from(document.querySelectorAll('.ron-section-text'));

  // pick the section that crosses the viewport center
  function updateActive() {
    const centerY = window.innerHeight / 2;
    let activeIndex = -1;

    sections.forEach((section, i) => {
      const r = section.getBoundingClientRect();
      const hitsCenter = r.top <= centerY && r.bottom >= centerY;
      if (hitsCenter) activeIndex = i;
    });

    texts.forEach((t, i) => t.classList.toggle('active', i === activeIndex));
  }

  // run once and on scroll/resize (throttled with rAF)
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        updateActive();
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('load', updateActive);
  updateActive();
////Vertical Carousel//////

/////// ND Accordion – PDP + Quick Add ///////
(function () {
  const openItem = (item) => {
    const panel = item.querySelector(".nd-panel");
    const trigger = item.querySelector(".nd-trigger");
    if (!panel || !trigger) return;

    panel.style.maxHeight = panel.scrollHeight + "px";
    trigger.style.color = "black";
    item.classList.add("active");

    const onEnd = (e) => {
      if (e.propertyName === "max-height") {
        panel.style.maxHeight = "none";
        panel.removeEventListener("transitionend", onEnd);
      }
    };
    panel.addEventListener("transitionend", onEnd);
  };

  const closeItem = (item) => {
    const panel = item.querySelector(".nd-panel");
    const trigger = item.querySelector(".nd-trigger");
    if (!panel || !trigger) return;

    if (panel.style.maxHeight === "" || panel.style.maxHeight === "none") {
      panel.style.maxHeight = panel.scrollHeight + "px";
      panel.getBoundingClientRect(); // force reflow
    }

    panel.style.maxHeight = "0px";
    trigger.style.color = "#555";
    item.classList.remove("active");
  };

  document.addEventListener("DOMContentLoaded", () => {
    const accordions = document.querySelectorAll(".nd-accordion");
    accordions.forEach((accordion) => {
      const firstItem = accordion.querySelector(".nd-item");
      if (firstItem) openItem(firstItem);
    });
  });

  document.addEventListener("click", (e) => {
    const trigger = e.target.closest(".nd-trigger");
    if (!trigger) return;

    const item = trigger.closest(".nd-item");
    if (!item) return;

    const accordion = item.closest(".nd-accordion") || document;
    const currentActive = accordion.querySelector(".nd-item.active");
    const isSame = currentActive === item;

    if (currentActive && !isSame) {
      closeItem(currentActive);
    }

    if (!isSame) {
      const panel = item.querySelector(".nd-panel");
      if (panel) panel.style.maxHeight = "0px";
      requestAnimationFrame(() => openItem(item));
    } else {
      // Clicking the open one closes it
      closeItem(item);
    }
  });
})();
/////// ND Accordion ///////
document.addEventListener("DOMContentLoaded", function () {
  const trustIcons = document.querySelectorAll(".trust-icon");

  trustIcons.forEach(function (icon) {
    const btn = icon.querySelector(".trust-info-btn");
    const tooltip = icon.querySelector(".trust-tooltip");

    if (!btn || !tooltip) return;

    // Click on "i" → toggle this tooltip
    btn.addEventListener("click", function (e) {
      e.stopPropagation();

      // Close all other open tooltips
      document.querySelectorAll(".trust-tooltip.is-open").forEach(function (tt) {
        if (tt !== tooltip) tt.classList.remove("is-open");
      });

      // Toggle the current one
      tooltip.classList.toggle("is-open");
    });
  });

  // Close all tooltips when clicking outside
  document.addEventListener("click", function () {
    document.querySelectorAll(".trust-tooltip.is-open").forEach(function (tt) {
      tt.classList.remove("is-open");
    });
  });
});
// // // // // // Edited BY Nikita // // // // // // 

// accordion code start
// accordion code start

//      (function() {
//     const initializeAccordion = () => {
//         const accordionItemHeaders = document.querySelectorAll(".f-navlist p");
//         accordionItemHeaders.forEach(header => {
//             header.removeEventListener("click", toggleAccordion);
//         });

//         accordionItemHeaders.forEach((accordionItemHeader) => {
//             accordionItemHeader.addEventListener("click", toggleAccordion);
//         });
//       // Edited by nikita
//       // Open the first accordion by default
//         const firstHeader = accordionItemHeaders[1];
//         if (firstHeader) {
//             firstHeader.classList.add("active");
//             const firstBody = firstHeader.nextElementSibling;
//             if (firstBody) {
//                 firstBody.style.maxHeight = firstBody.scrollHeight + "px";
//             }
//         }
//     };

//     const toggleAccordion = (event) => {
//         const accordionItemHeader = event.currentTarget;
//         const currentlyActiveAccordionItemHeader = document.querySelector(".f-navlist p.active");

//         if (currentlyActiveAccordionItemHeader && currentlyActiveAccordionItemHeader !== accordionItemHeader) {
//             currentlyActiveAccordionItemHeader.classList.remove("active");
//             currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
//         }
//         accordionItemHeader.classList.toggle("active");
//         const accordionItemBody = accordionItemHeader.nextElementSibling;
//         if (accordionItemHeader.classList.contains("active")) {
//             accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
//         } else {
//             accordionItemBody.style.maxHeight = 0;
//         }
//     };
//     initializeAccordion();
// })();

// accordion code end

// accordion code end

// --------------------Footer Accordian --------------------------------

// --------------------Menu Accordian --------------------------------


// product accordion start
(function() {
    const initializeAccordion = () => {
        const accordionItemHeaders = document.querySelectorAll(".accordion-item-header");

        // Remove previous event listeners to prevent stacking
        accordionItemHeaders.forEach(header => {
            header.removeEventListener("click", toggleAccordion);
        });

        if (accordionItemHeaders.length > 0) {
            accordionItemHeaders.forEach((accordionItemHeader) => {
                accordionItemHeader.addEventListener("click", toggleAccordion);
            });

      // Edited by nikita
      // Open the third accordion by default
            // const defaultIndex = 2; // 0-based index → 3rd item
            // if (accordionItemHeaders[defaultIndex]) {
            //     accordionItemHeaders[defaultIndex].classList.add("active");
            //     const accordionItemBody = accordionItemHeaders[defaultIndex].nextElementSibling;
            //     accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
            // }
        }
    };

    const toggleAccordion = (event) => {
        const accordionItemHeader = event.currentTarget;
        const currentlyActiveAccordionItemHeader = document.querySelector(".accordion-item-header.active");

        if (currentlyActiveAccordionItemHeader && currentlyActiveAccordionItemHeader !== accordionItemHeader) {
            currentlyActiveAccordionItemHeader.classList.remove("active");
            currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
        }

        accordionItemHeader.classList.toggle("active");
        const accordionItemBody = accordionItemHeader.nextElementSibling;
        if (accordionItemHeader.classList.contains("active")) {
            accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px"; // Set max-height to scroll height
        } else {
            accordionItemBody.style.maxHeight = 0;
        }
    };

    // Call the function to initialize the accordion
    initializeAccordion();
})();


// --------------------Menu Accordian --------------------------------
